import { RouteRecordRaw } from "vue-router"

export const userRoutes: RouteRecordRaw[] = [
	{
		path: "/login",
		name: "login",
		component: () => import("@/views/user/login.vue")
	},
	{
		path: "/unboundAccount",
		name: "unboundAccount",
		component: () => import("@/views/user/unboundAccount.vue")
	},
	{
		path: "/bindAccount",
		name: "bindAccount",
		component: () => import("@/views/user/bindAccount.vue")
	},
	{
		path: "/perfectOne",
		name: "perfectOne",
		component: () => import("@/views/user/perfectOne.vue")
	},
	{
		path: "/perfectTwo",
		name: "perfectTwo",
		component: () => import("@/views/user/perfectTwo.vue")
	},
	{
		path: "/perfectThree",
		name: "perfectThree",
		component: () => import("@/views/user/perfectThree.vue")
	},
	{
		path: "/perfectFour",
		name: "perfectFour",
		component: () => import("@/views/user/perfectFour.vue")
	},
	{
		path: "/perfectFive",
		name: "perfectFive",
		component: () => import("@/views/user/perfectFive.vue")
	},
	{
		path: "/perfectSix",
		name: "perfectSix",
		component: () => import("@/views/user/perfectSix.vue")
	},
	{
		path: "/perfectSeven",
		name: "perfectSeven",
		component: () => import("@/views/user/perfectSeven.vue")
	},
	{
		path: "/infoConfirm",
		name: "infoConfirm",
		component: () => import("@/views/user/infoConfirm.vue")
	},
	{
		path: "/confirmSuccess",
		name: "confirmSuccess",
		component: () => import("@/views/user/confirmSuccess.vue")
	},
	{
		path: "/review",
		name: "review",
		component: () => import("@/views/user/review.vue")
	},
	{
		path: "/accountDetail",
		name: "accountDetail",
		component: () => import("@/views/mine/accountDetail.vue")
	},
	{
		path: "/guardiansManagement",
		name: "guardiansManagement",
		component: () => import("@/views/mine/guardiansManagement.vue")
	},
	{
		path: "/applyBindRecord",
		name: "applyBindRecord",
		component: () => import("@/views/mine/applyBindRecord.vue")
	},
	{
		path: "/goWeiXin",
		name: "goWeiXin",
		component: () => import("@/views/mine/goWeiXin.vue")
	}
]
